// skipcq: JS-W1028, JS-0128
import React from 'react';

/** SVG fragment id for a pie segment; must match `Cell` `fill={url(#…)}`. */
export function chartPatternFragmentId(uniqueId, segmentKey) {
  const safe = String(segmentKey).replace(/[^a-zA-Z0-9_-]/g, '_');
  return `${uniqueId}-pat-${safe}`;
}

/**
 * Inline SVG <defs> with one <pattern> per pie segment — use with Recharts
 * `<Cell fill={\`url(#${chartPatternFragmentId(uniqueId, segmentKey)})\`} />`.
 *
 * Grain uses fractal noise (stitched turbulence) plus a soft-light blend so slices read
 * like card/parchment rather than flat fills.
 *
 * @param {string} uniqueId - Stable id prefix, e.g. useId().replace(/:/g, '')
 * @param {{ segmentKey: string, fill: string }[]} segments - One entry per slice (same order as Cells)
 */
function ChartSegmentPatternDefs({ uniqueId, segments = [] }) {
  if (!segments.length) {
    return null;
  }

  const grainFilterId = `${uniqueId}-paper-grain-filter`;

  return (
    <defs>
      <filter
        id={grainFilterId}
        x="-50%"
        y="-50%"
        width="200%"
        height="200%"
        colorInterpolationFilters="sRGB"
      >
        <feTurbulence
          type="fractalNoise"
          baseFrequency="3.92"
          numOctaves="4"
          stitchTiles="stitch"
          result="grainRaw"
        />
        <feColorMatrix
          in="grainRaw"
          type="saturate"
          values="0"
          result="grainGrey"
        />
        <feComponentTransfer in="grainGrey" result="grain">
          <feFuncA type="linear" slope="0.01" intercept=".25" />
        </feComponentTransfer>
        <feBlend in="SourceGraphic" in2="grain" mode="soft-light" />
      </filter>
      {segments.map(({ segmentKey, fill: baseColor }) => (
        <pattern
          key={segmentKey}
          id={chartPatternFragmentId(uniqueId, segmentKey)}
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <g filter={`url(#${grainFilterId})`}>
            <rect width="1" height="1" fill={baseColor} />
          </g>
        </pattern>
      ))}
    </defs>
  );
}

export default ChartSegmentPatternDefs;
